import { dateConverter } from "../../../../../common/utils/dateConverter";
import { useSingleMinigrid } from "../../../hook";
import DescriptionMinigridView from "./DescriptionMinigridView/DescriptionMinigridView";

export default function DescriptionMinigridPresenter() {

    const {singleMinigridQuery:{data}} = useSingleMinigrid()

    const createAt = data?.minirgrid_created_at
    ? dateConverter(data?.minirgrid_created_at)
    : undefined;

  const updatedAt = data?.minirgrid_updated_at
    ? dateConverter(data?.minirgrid_updated_at)
    : undefined;

  return (
    <DescriptionMinigridView text={data?.minigrid_description}
    createdAt={createAt}
    updatedAt={updatedAt}
    installationCode={data?.minigrid_installation_code}
    />
  ) 
}
